// extracted by mini-css-extract-plugin
export default {"form":"_01_Email_form__yreu+","root":"_01_Email_root__6hYgW"};